import React from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

const PowerBIReport = ({ reportId, embedUrl, accessToken, tokenType = models.TokenType.Embed }) => {
    const embedConfig = {
        type: 'report',
        id: reportId,
        embedUrl: embedUrl,
        accessToken: accessToken,
        tokenType: tokenType,
        settings: {
            filterPaneEnabled: true,
            navContentPaneEnabled: true,
        },
    };

    return (
        <PowerBIEmbed
            embedConfig={embedConfig}
            eventHandlers={
                new Map([
                    ['loaded', function () { console.log('Report loaded'); }],
                    ['rendered', function () { console.log('Report rendered'); }],
                    ['error', function (event) { console.log('Error:', event.detail); }]
                ])
            }
            cssClassName='h-100'
        />
    );
};

export default PowerBIReport;
